/* eslint-disable react-hooks/exhaustive-deps */
import ErrorPage from '../containers/ErrorPage';
import React, { useEffect } from 'react';
import LogCannon from '@ace-clublabs/log-cannon';
import { Routes, Route, useLocation } from 'react-router';
import ConfirmationPage from '../containers/ConfirmationPage';
import ReviewPage from '../containers/ReviewPage';
import VerifyEligibilityPage from '../containers/VerifyEligibilityPage';
import UpdateEmailsPage from '../containers/UpdateEmailsPage';
import { Pages } from '../shared/pages';
import AutopayEnrollmentPage from '../containers/AutopayEnrollmentPage';
import { useGlobalState } from '../shared/state';
import { ErrorType } from '../shared/types';

const Router: React.FC = () => {
  let location = useLocation();
  React.useEffect(() => {
    LogCannon.blast(`Navigate to ${location.pathname}`, {
      pathname: location.pathname,
      search: location.search,
    });
  }, [location]);

  const errorPageProps = { errorType: location.state?.errorType as ErrorType };

  const state = {
    amountDue: useGlobalState('amountDue')[0],
    membershipNumber: useGlobalState('membershipNumber')[0],
    membershipLevel: useGlobalState('membershipLevel')[0],
    zipCode: useGlobalState('zipCode')[0],
    autoPay: useGlobalState('autoPay')[0],
    clubCode: useGlobalState('clubCode')[0],
    autoPayEnrolled: useGlobalState('autoPayEnrolled')[0],
    optedDiscount: useGlobalState('optedDiscount')[0],
    emailOnFile: useGlobalState('emailOnFile')[0],
    campaignCode: useGlobalState('campaignCode')[0],
    taxAmount: useGlobalState('taxAmount')[0],
    preDiscountAmountDue: useGlobalState('preDiscountAmountDue')[0],
    productCost: useGlobalState('productCost')[0],
    appFlow: useGlobalState('appFlow')[0],
    isMobileApp: useGlobalState('isMobileApp')[0],
    membershipProductRV: useGlobalState('membershipProductRV')[0],
    billPlan: useGlobalState('billPlan')[0],
  };

  useEffect(() => {
    sessionStorage.setItem('membershipPwolState', JSON.stringify(state));
  }, [state]);

  return (
    <Routes>
      <Route path={Pages.VerifyEligibility} element={<VerifyEligibilityPage />} />
      <Route path={Pages.Review} element={<ReviewPage />} />
      <Route path={Pages.Confirmation} element={<ConfirmationPage />} />
      <Route path={Pages.UpdateEmails} element={<UpdateEmailsPage />} />
      <Route path={Pages.AutoPay} element={<AutopayEnrollmentPage />} />
      <Route path={Pages.Error} element={<ErrorPage {...errorPageProps} />} />{' '}
    </Routes>
  );
};

export default Router;
